<div
  [id]="panelId"
  class="cart-panel"
  [class.is-open]="open"
  role="dialog"
  aria-modal="false"
  [attr.aria-labelledby]="panelId + '-title'"
  [attr.aria-hidden]="!open"
  tabindex="-1"
>
  <span class="sheet-handle d-lg-none" aria-hidden="true"></span>
  <header class="cart-panel-header">
    <h2 [id]="panelId + '-title'" class="cart-panel-title">Your cart</h2>
    <button type="button" class="cart-panel-close" aria-label="Close cart" (click)="dismiss.emit(true)">
      <span aria-hidden="true">&times;</span>
    </button>
  </header>

  <section *ngIf="empty" class="cart-empty" aria-live="polite">
    <span class="cart-empty-icon" aria-hidden="true"><i class="icon-shopping-cart"></i></span>
    <p class="cart-empty-title">Your cart is empty</p>
    <p class="cart-empty-copy">
      {{ showShop ? "Rent equipment by the day, week or month, or buy attachments and parts." : "Rent equipment by the day, week or month." }}
    </p>
    <div class="cart-empty-actions" [class.cart-empty-actions-split]="showShop">
      <a class="btn btn-primary" routerLink="/equipment-rentals/all" (click)="dismiss.emit(false)">Browse rentals</a>
      <a *ngIf="showShop" class="btn btn-outline-dark" routerLink="/shop/attachments" (click)="dismiss.emit(false)">Shop attachments</a>
    </div>
  </section>

  <ng-container *ngIf="!empty">
    <section class="cart-row" rt="header-cart-rentals" [attr.aria-labelledby]="panelId + '-rentals'">
      <div class="cart-row-text">
        <h3 [id]="panelId + '-rentals'" class="cart-row-name">Rentals</h3>
        <p class="cart-row-meta">{{ rentalCount ? itemLabel(rentalCount) : "No items yet" }}</p>
      </div>
      <a *ngIf="rentalCount; else browseRentals" class="btn btn-primary cart-row-action" routerLink="/cart" (click)="dismiss.emit(false)">Rental checkout</a>
      <ng-template #browseRentals>
        <a class="btn btn-outline-dark cart-row-action" routerLink="/equipment-rentals/all" (click)="dismiss.emit(false)">Browse rentals</a>
      </ng-template>
    </section>

    <section *ngIf="showShop" class="cart-row" rt="header-cart-shop" [attr.aria-labelledby]="panelId + '-shop'">
      <div class="cart-row-text">
        <h3 [id]="panelId + '-shop'" class="cart-row-name">Shop</h3>
        <p class="cart-row-meta">{{ shopCount ? itemLabel(shopCount) : "No items yet" }}</p>
      </div>
      <a *ngIf="shopCount; else shopAttachments" class="btn btn-primary cart-row-action" routerLink="/shop/cart" (click)="dismiss.emit(false)">View Shop cart</a>
      <ng-template #shopAttachments>
        <a class="btn btn-outline-dark cart-row-action" routerLink="/shop/attachments" (click)="dismiss.emit(false)">Shop attachments</a>
      </ng-template>
    </section>
  </ng-container>
</div>
